module.exports = __webpack_public_path__ + "static/media/waterdrop.e451aca9.png";